import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BaseAppState } from '../../store/reducers';
import { AuthSelectors } from '../selectors/auth.selectors';
import { AUTH_UI_PATH_ELEMENTS } from '../definitions/auth-ui-navigation.definitions';

@Injectable()
export class AdminLoggedInGuard implements CanActivate {
  private readonly isLoggedIn$ = this.store.pipe(select(AuthSelectors.isLoggedIn));

  constructor(private readonly router: Router, private readonly store: Store<BaseAppState>) {}

  canActivate(
    _route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | boolean | UrlTree {
    return this.isLoggedIn$.pipe(
      map((loggedIn) => {
        if (loggedIn) {
          return true;
        }
        const redirectUrlTree = this.router.createUrlTree(
          ['/', AUTH_UI_PATH_ELEMENTS.rootElement, AUTH_UI_PATH_ELEMENTS.root.admin],
          { queryParams: { returnUrl: state.url } }
        );
        return redirectUrlTree;
      })
    );
  }
}
